import { TOGGLE_PREFIX } from 'app/resources'

import { useQueryApi } from 'utils/api'

export const basePath = '/cores/v1alpha1/toggles'

export interface ResponseGetToggles {
  toggle: {
    key: string
    isEnabled: boolean
    description: string
  }
}

export const useAPIGetToggles = (key: string) =>
  useQueryApi<ResponseGetToggles>(`${basePath}/${TOGGLE_PREFIX + key}`, {
    queryConfig: {
      enabled: !!key,
    },
  })
